module.exports = __webpack_public_path__ + "static/media/corporate-services-img54.572f0258.jpg";